/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import axios from 'axios';
import { loginToken, localLoginToken } from '../../authorization/login';
import { ALERT_SHOW } from '../alerts/alertActionTypes';
import {
    FETCH_PRODUCTS_DATA,
    FETCH_PRODUCTS_SUMMARY,
    CREATE_PRODUCT,
    DELETE_PRODUCT,
    PRODUCT_FORM_INPUT,
    PRODUCT_FORM_INPUT_ARRAY,
    INPUT_IMAGE_MULTIPLE,
    GET_PRODUCT_CATEGORIES,
    SET_SINGLE_PRODUCT,
    UPDATE_PRODUCT,
    SET_LOADING_STATE,
    RESET_PRODUCT_FORM,
    INPUT_IMAGE_FEATURE,
    RESET_FEATURE_IMAGE,
    PRODUCT_DOWNLOADABLE,
    SET_COVER_IMAGE_STATE,
    SET_GALLERY_IMAGE_STATE,
    REMOVE_GALLERY_IMAGE,
} from './productsActionTypes';
import { fetchData } from '../../api/GET/fetchData';
import {
    productCategoriesAPI,
    productsAPI,
    products_API_V1,
    productSummaryAPI,
    media_API_V2,
} from '../../api/ENDPOINTS/products';
import { productsOverview } from '../../api/ENDPOINTS/overview';
import { dismissAlert } from '../alerts/alertsActions';
import { getRequest, putRequest, uploadMedia } from '../../utils/requests';

/**
 * Create new product
 * Action:
 * Create Product
 * Payload:
 * 1.Response 200 Ok
 */

export function createProduct({ formData }) {
    // product Data
    const newProduct = formData;
    // merge feature and gallery image
    console.log('From Redux actions ', newProduct);

    return async (dispatch) => {
        dispatch({
            type: SET_LOADING_STATE,
            payload: true,
        });
        // api will be place here...
        const response = await axios.post(productsAPI, newProduct, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Basic ${localLoginToken}`,
            },
        });
        // console.log(response);
        const alert = {
            message: 'product successfully created...!!!',
            alertType: 'success',
            status: 200,
        };
        dispatch({ type: ALERT_SHOW, payload: alert });
        // after response from axios request.
        dispatch({ type: CREATE_PRODUCT });
        dispatch({
            type: SET_LOADING_STATE,
            payload: false,
        });
    };
}

export function updateProduct({ formData }) {
    // product Data
    const updateProductData = formData;
    // eslint-disable-next-line array-callback-return
    updateProductData.downloads.map((item) => {
        if (item.id !== undefined) {
            // eslint-disable-next-line no-param-reassign
            item.id = item.id.toString();
        }
    });
    return async (dispatch) => {
        dispatch({
            type: SET_LOADING_STATE,
            payload: true,
        });
        // api will be place here...
        const response = await putRequest(products_API_V1, updateProductData.id, updateProductData);
        const alert = {
            message: 'product successfully updated...!!!',
            alertType: 'success',
            status: 200,
        };
        dispatch({ type: ALERT_SHOW, payload: alert });
        // after response from axios request.
        dispatch({ type: UPDATE_PRODUCT });
        dispatch({
            type: SET_LOADING_STATE,
            payload: false,
        });
    };
}
/* Fetching Products Summary
ACTION: 
1. Fetch Products Summary

Payload: 
1. Response Data
*/
export const fetchProductsSummary = () => async (dispatch) => {
    const response = await fetchData(productsOverview);
    dispatch({
        type: FETCH_PRODUCTS_SUMMARY,
        payload: response?.data,
    });
};

/* Fetching All Products Data
ACTION: 
1. Initial Product Data Fetching
2. Fetch Again if any Query ParameterChanges

Payload: 
1. Response Data
2. Total Product Page (from Header)
*/
export const fetchProductsData = (queryStatus = '') => async (dispatch, getState) => {
    // console.log(getState());
    const response = await getRequest(products_API_V1, queryStatus);

    dispatch({
        type: FETCH_PRODUCTS_DATA,
        payload: response.data,
        productsTotalPages: response.headers['x-wp-totalpages'],
    });
    dispatch({
        type: SET_LOADING_STATE,
        payload: false,
    });
};

/**
 *
 * @param {id} product
 * @returns {product}
 */

export const getSingleProduct = (product) => async (dispatch) => {
    dispatch({
        type: SET_SINGLE_PRODUCT,
        payload: product,
    });
};

/* Title: Product Trash
 * Description: this actions perform delete specific products
 * Author: Majeed
 * Date: 2021-10-21
 */

export const deleteProduct = (product = []) => async (dispatch) => {
    // api will be place here...
    dispatch({
        type: SET_LOADING_STATE,
        payload: true,
    });
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < product.length; i++) {
        const element = product[i];
        // eslint-disable-next-line no-await-in-loop
        const response = await axios.delete(`${productsAPI}/${element}`, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Basic ${localLoginToken}`,
            },
        });
    }

    const alert = {
        message: 'product successfully deleted...!!!',
        alertType: 'success',
        status: 200,
    };
    dispatch({ type: ALERT_SHOW, payload: alert });
    dispatch(fetchProductsData());
    dispatch({
        type: SET_LOADING_STATE,
        payload: false,
    });
    setTimeout(() => {
        dispatch(dismissAlert());
    }, 5000);
};

// product input actions

export const handleProductInput = (name, value, e, isEdit = false) => (dispatch) => {
    const data = {
        name,
        value,
    };
    dispatch({ type: PRODUCT_FORM_INPUT, payload: data });
};
export const handleProductInputArray = (name, values = [], e, isEdit = false) => (dispatch) => {
    const data = {
        name,
        values,
    };
    dispatch({ type: PRODUCT_FORM_INPUT_ARRAY, payload: data });
};
export const handleFeaturedImage = (name, value, e, isEdit = false) => async (dispatch) => {
    dispatch({
        type: SET_COVER_IMAGE_STATE,
        payload: true,
    });
    const data = {
        id: 0,
        src: '',
        name: '',
        position: 0,
    };

    // const response = await axios
    //     .post(media_API_V2, value, {
    //         headers: {
    //             Authorization: `Basic ${localLoginToken}`,
    //             'Content-Disposition': `attachment; filename="${name}"`,
    //         },
    //     })
    //     .then((res) => {
    //         data.id = res.data.id;
    //         data.src = res.data.source_url;
    //         data.name = res.data.slug;
    //         data.position = 0;
    //     });
    const response = await uploadMedia(value);
    data.id = response.data.id;
    data.src = response.data.source_url;
    data.name = response.data.slug;
    data.position = 0;
    console.log('handleFeature');
    await dispatch({ type: INPUT_IMAGE_FEATURE, payload: data });
    await dispatch({
        type: SET_COVER_IMAGE_STATE,
        payload: false,
    });
};
export const handleProdcutMultipleImage = (name, value, e, isEdit = false) => async (
    dispatch,
    getState
) => {
    // eslint-disable-next-line camelcase
    const { galleryImages } = getState().products.productInputData;
    const nextPosition = galleryImages.length + 1;
    dispatch({
        type: SET_GALLERY_IMAGE_STATE,
        payload: true,
    });
    const data = {
        id: 0,
        src: '',
        name: '',
        position: nextPosition,
    };

    // const response = await axios
    //     .post(media_API_V2, value, {
    //         headers: {
    //             Authorization: `Basic ${localLoginToken}`,
    //             'Content-Disposition': `attachment; filename="${name}"`,
    //         },
    //     })
    //     .then((res) => {
    //         data.id = res.data.id;
    //         data.src = res.data.source_url;
    //         data.name = res.data.slug;
    //     });

    const response = await uploadMedia(value);
    data.id = response.data.id;
    data.src = response.data.source_url;
    data.name = response.data.slug;
    await dispatch({ type: INPUT_IMAGE_MULTIPLE, payload: data });
    await dispatch({
        type: SET_GALLERY_IMAGE_STATE,
        payload: false,
    });
};

export const getProductCategories = () => async (dispatch) => {
    const response = await fetchData(productCategoriesAPI);
    dispatch({
        type: GET_PRODUCT_CATEGORIES,
        payload: response.data,
    });
};

/**
 * Downloadable product
 * @returns {void}
 */

export const handleDownloadable = (data) => async (dispatch) => {
    dispatch({
        type: PRODUCT_DOWNLOADABLE,
        payload: data,
    });
};

/**
 * Loading State
 */

export const setLoading = () => (dispatch) => {
    dispatch({
        type: SET_LOADING_STATE,
        payload: true,
    });
};

/**
 * Reset Product Form..
 *
 */

export const resetProductForm = () => async (dispatch, getState) => {
    const { resetInputData } = getState().products;
    dispatch({
        type: RESET_PRODUCT_FORM,
        payload: resetInputData,
    });
};

/**
 * reset feature image of product
 *
 */

export const resetFeatureImage = (data) => async (dispatch, getState) => {
    // const { images } = getState().products.productInputData;
    dispatch({ type: RESET_FEATURE_IMAGE, payload: data });
};

/**
 * remove gallery images.
 * @return {void}
 */

export const removeGalleryImage = (file) => async (dispatch) => {
    dispatch({
        type: SET_GALLERY_IMAGE_STATE,
        payload: true,
    });
    await dispatch({
        type: REMOVE_GALLERY_IMAGE,
        payload: file,
    });
    dispatch({
        type: SET_GALLERY_IMAGE_STATE,
        payload: false,
    });
};
